import { Component } from '@nicolas-riciotti/light2';

// JSON shape to type out on the left, with the matching UI step that should
// reveal once the corresponding line has been typed.
const SCHEMA_LINES = [
    { text: '{',                                                          step: 'container' },
    { text: '  "title": "Product",',                                       step: null },
    { text: '  "type": "object",',                                         step: null },
    { text: '  "properties": {',                                           step: null },
    { text: '    "thumbnail":    { "type": "image" },',                    step: 'thumb' },
    { text: '    "category":     { "type": "string" },',                   step: 'category' },
    { text: '    "name":         { "type": "string" },',                   step: 'name' },
    { text: '    "description":  { "type": "string" },',                   step: 'description' },
    { text: '    "price":        { "type": "number", "currency": "USD" },', step: 'price' },
    { text: '    "stock": {',                                              step: 'divider' },
    { text: '      "status":     "in_stock",',                             step: 'stock' },
    { text: '      "shipping":   "1-2 business days"',                     step: null },
    { text: '    },',                                                      step: null },
    { text: '    "gallery": [',                                            step: null },
    { text: '      { "type": "image" },',                                  step: 'small-1' },
    { text: '      { "type": "image" },',                                  step: 'small-2' },
    { text: '      { "type": "image" }',                                   step: 'small-3' },
    { text: '    ],',                                                      step: null },
    { text: '    "details": {',                                            step: 'details-heading' },
    { text: '      "color":    { "type": "array" },',                      step: 'color' },
    { text: '      "size":     { "type": "string" },',                     step: 'size' },
    { text: '      "material": { "type": "string" }',                      step: 'material' },
    { text: '    },',                                                      step: null },
    { text: '    "returns": {',                                            step: null },
    { text: '      "policy":   "30-day",',                                 step: null },
    { text: '      "shipping": "see policy"',                              step: 'returns' },
    { text: '    }',                                                       step: null },
    { text: '  }',                                                         step: null },
    { text: '}',                                                           step: null },
];

const CHAR_DELAY_MS = 4;    // typing speed
const LINE_PAUSE_MS = 18;   // extra pause between lines

export default class BlockArticleSchema extends Component {

    attached() {
        this.$code = this.querySelector('[data-schema-json]');
        this.$steps = new Map();
        this.querySelectorAll('[data-schema-step]').forEach(el => {
            this.$steps.set(el.getAttribute('data-schema-step'), el);
        });

        // Hide the "empty state" image as soon as the container will start
        // building, so the two don't visually fight.
        this.$emptyState = this.querySelector('[data-schema-ui-empty]');

        this._started = false;
        this._raf = null;

        if (!this.$code) return;

        // The JSON panel now stretches to match the structured-output panel
        // height (flex-1 + items-stretch in the markup), so no min-height
        // reservation is needed — start empty and type in.
        this.$code.textContent = '';

        // Trigger when the section scrolls into view.
        if ('IntersectionObserver' in window) {
            this._io = new IntersectionObserver((entries) => {
                for (const e of entries) {
                    if (e.isIntersecting && !this._started) {
                        this._started = true;
                        this._io.disconnect();
                        this.runAnimation(window.innerWidth < 600);
                        break;
                    }
                }
            }, { threshold: 0.35 });
            this._io.observe(this);
        } else {
            this._started = true;
            this.runAnimation(window.innerWidth < 600);
        }
    }

    detached() {
        this._io?.disconnect();
        if (this._raf) cancelAnimationFrame(this._raf);
        if (this._timer) clearTimeout(this._timer);
    }

    revealStep(stepKey) {
        if (!stepKey) return;
        const el = this.$steps.get(stepKey);
        if (!el) return;
        // If the container appears, fade the empty-state out.
        if (stepKey === 'container' && this.$emptyState) {
            this.$emptyState.style.transition = 'opacity 0.4s ease-out';
            this.$emptyState.style.opacity = '0';
        }
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
    }

    runAnimation(mobile) {
        console.log('RUN_ANIAMTION', mobile);

        let lineIdx = 0;
        let buffer = '';

        const typeLine = () => {
            if (lineIdx >= SCHEMA_LINES.length) return;
            const line = SCHEMA_LINES[lineIdx];
            const target = (buffer ? buffer + '\n' : '') + line.text;
            let i = buffer ? buffer.length + 1 : 0; // index into target
            const fullStart = (buffer ? buffer.length + 1 : 0);

            const typeChar = () => {
                if (i < target.length) {
                    this.$code.textContent = target.substring(0, i + 1);
                    i++;
                    if (mobile) {
                        typeChar()
                    }
                    else {
                        this._timer = setTimeout(typeChar, mobile ? 0 : CHAR_DELAY_MS);
                    }
                } else {
                    buffer = target;
                    // Reveal the UI step tied to this line.
                    this.revealStep(line.step);
                    lineIdx++;
                    if (mobile) {
                        typeLine()
                    }
                    else {
                        this._timer = setTimeout(typeLine, mobile ? 0 : LINE_PAUSE_MS);
                    }
                }
            };
            typeChar();
        };

        typeLine();
    }
}

customElements.define('block-article-schema', BlockArticleSchema);
